// extracted by mini-css-extract-plugin
export var form = "area-page-module--form--1895c";
export var loader = "area-page-module--loader--3d671";
export var load6 = "area-page-module--load6--d277d";
export var round = "area-page-module--round--91980";
export var loaderWrapper = "area-page-module--loaderWrapper--9c6d1";